import { graphql } from 'gql'

export const REFRESH_TOKEN = graphql(`
  mutation refreshToken($refreshToken: String!, $canAccessGamConnection: Boolean!) {
    refreshToken(input: { refreshToken: $refreshToken }) {
      accessToken
      refreshToken

      user {
        ...AuthUserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`)
